
import React from 'react';
import { ImageUpload } from './ImageUpload';

export const BannerUploadSection = () => {
  return (
    <div className="bg-blue-600/20 backdrop-blur-sm p-6 rounded-lg shadow-lg border border-blue-300/30">
      <h2 className="text-2xl font-bold text-white mb-4">Banner Bild Upload (NS1)</h2>
      <p className="text-white mb-4">
        Hier können Sie das Banner Bild der Website hochladen. Nach dem Hochladen wird die Seite automatisch aktualisiert.
      </p>
      <ImageUpload defaultSection="new-banner" />
    </div>
  );
};
